import { useCallback, useRef, useState } from 'react'

export type GuideLines = {
    vertical: number[]
    horizontal: number[]
}

const emptyGuides = (): GuideLines => ({ vertical: [], horizontal: [] })

/** Состояние направляющих: показ при drag и краткий flash после nudge. */
export const useTemplateEditorGuides = () => {
    const [guides, setGuidesState] = useState<GuideLines>(emptyGuides)
    const hideTimerRef = useRef<ReturnType<typeof setTimeout> | null>(null)

    const clearHideTimer = () => {
        if (hideTimerRef.current) {
            clearTimeout(hideTimerRef.current)
            hideTimerRef.current = null
        }
    }

    const setGuides = useCallback((vertical: number[], horizontal: number[]) => {
        clearHideTimer()
        setGuidesState((prev) => {
            if (
                prev.vertical.length === vertical.length &&
                prev.horizontal.length === horizontal.length &&
                prev.vertical.every((value, index) => value === vertical[index]) &&
                prev.horizontal.every((value, index) => value === horizontal[index])
            ) {
                return prev
            }

            return { vertical, horizontal }
        })
    }, [])

    const clearGuides = useCallback(() => {
        clearHideTimer()
        setGuidesState(emptyGuides())
    }, [])

    const showGuidesBriefly = useCallback((vertical: number[], horizontal: number[]) => {
        clearHideTimer()

        if (!vertical.length && !horizontal.length) {
            setGuidesState(emptyGuides())
            return
        }

        setGuidesState({ vertical, horizontal })
        hideTimerRef.current = setTimeout(() => {
            setGuidesState(emptyGuides())
            hideTimerRef.current = null
        }, 600)
    }, [])

    return {
        guides,
        setGuides,
        clearGuides,
        showGuidesBriefly,
    }
}
